import React from "react";
import { Switch, Route } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/background5.jpg";
import logo from "assets/img/logo2.png";
import logoCaracas from "assets/img/logo-caracas.png";
import logoComunidanas from "assets/img/logo-comunidanas.jpg";
import logoMujer from "assets/img/logo-mujer.jpg";
import logoOportunidad from "assets/img/logo-oportunidad.jpg";
import logoPeople from "assets/img/logo-people.jpg";
import logoReconciliaccion from "assets/img/logo-reconciliaccion.jpg";
import logoUniversidad from "assets/img/logo-universidad.gif";
import signature from "assets/img/signature.jpg";


let ps;

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return <Route path={prop.path} render={(props) => <prop.component {...props} iframeUrl={prop.iframeUrl} />} key={key} />;
    })}
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const image = bgImage;
  const color = "blue";

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  return (
    <div className={classes.wrapperContainer}>
      <Sidebar
        routes={routes}
        logoText={"Logo"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
            <div className={classes.content}>
              <div className={classes.homecontainer}>
                <div className={classes.headerTitle}>
                  <h3 className={classes.headerText}>EN SUCRE DEFENDEMOS LA SALUD COMO DERECHO HUMANO FUNDAMENTAL</h3>
                </div>

                <div className={classes.contentText}>
                  <p>
                    Fundación Comunidades Ciudadanas del Municipio Sucre (FUNDACOMUNIDANAS) en alianza con Caracas Ciudad Plural y el Proyecto ReconciliAcción inician el proyecto: Diagnóstico de la vulnerabilidad social, en el área de salud, en los habitantes del Municipio Sucre del Estado Bolivariano de Miranda. Proyecto ENPAS (Encuesta de Necesidades Prioritarias de Atención Social). Para acceder al cuestionario ENPAS puede seguir el siguiente enlace: <a href="https://arcg.is/5y8rX">https://arcg.is/5y8rX</a>.
                  </p>
                  <p>
                    Este proyecto aspira:
                  </p>
                  <ul>
                    <li>
                      Conocer las necesidades prioritarias en el área de salud, en enfermedades no transmisibles e infecciosas.
                    </li>
                    <li>
                      Identificación de riesgos biológicos, económicos, psicológicos y culturales
                    </li>
                    <li>
                      Determinar el Acceso al Sistema de Salud y de medicamentos de la población municipal.
                    </li>
                    <li>
                      Identificar zonas prioritarias de intervención y desarrollar un plan de acción consensuado con actores sociales, políticos y económicos.
                    </li>
                  </ul>
                  <p>
                    Nuestro municipio es el tercero más grande del país en población y la parroquia Petare es la más grande del país y una de las más grandes a nivel latinoamericano. Una de las características que tiene el municipio Sucre, es que es un municipio predictor, lo que significa que lo que sucede en Sucre se puede extrapolar a nivel nacional.
                  </p>
                  <p>
                    El contacto directo con las comunidades nos ha indicado que existe una gran vulnerabilidad social en el municipio Sucre, lo enriquecedor de este estudio, es que podamos levantar una data cierta para que puedan hacerse programas enfocados a las realidades de las diferentes comunidades.
                  </p>
                  <p>
                    Nuestra propuesta se orienta a dar una línea base sobre la situación de vulnerabilidad social, en el área de salud y compartir los resultados obtenidos con las distintas comunidades y entes competentes. Con esto podemos crear una data más completa y que sirva para desarrollar intervenciones en las distintas comunidades, de acuerdo a sus necesidades prioritarias. Este estudio permitirá tener una visión de las necesidades de salud del municipio y a partir de allí las comunidades o entes de gobierno podrán:
                  </p>
                  <ul>
                    <li>
                      Diseñar, implementar y hacer seguimiento a un plan de atención integral para fomentar el bienestar físico, mental y social para la población a través de la articulación con actores sociales y comunidades.
                    </li>
                    <li>
                      Integrar y fortalecer las acciones nacionales e internacionales para detección temprana y detección de enfermedades, combatir y controlar epidemias, desarrollar y mejorar buenas prácticas en materia de atención sanitaria universal, que contribuyan a incrementar y mejorar la atención a la ciudadanía.
                    </li>
                  </ul>
                  <p>
                    La presente es una iniciativa ciudadana que responde a más de 15 años de trabajo social en todo el municipio, creemos que con este esfuerzo podemos dar nuestro aporte a la generación de soluciones enfocadas a las verdaderas necesidades de los habitantes del municipio Sucre y que pudieran luego servir de base para el diagnóstico e intervención en otros municipios del país.
                  </p>
                  <div className={classes.signature}>
                    <img src={signature} alt="Signature" height="80" width="220" />
                    <p className={classes.signatureText}>
                      Manfredo González M.
                    </p>
                    <p className={classes.signatureText}>
                      Coordinador General de FUNDACOMUNIDANAS
                    </p>
                  </div>
                  <div className={classes.logos}>
                    <div className={classes.logo}>
                      <img src={logoComunidanas} alt="Logo" height="80" width="120" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoCaracas} alt="Logo" height="80" width="80" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoPeople} alt="Logo" height="80" width="100" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoReconciliaccion} alt="Logo" height="80" width="100" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoMujer} alt="Logo" height="80" width="100" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoOportunidad} alt="Logo" height="80" width="100" />
                    </div>
                    <div className={classes.logo}>
                      <img src={logoUniversidad} alt="Logo" height="80" width="100" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
}
